/**
 * 单校实时热度卡 — 在'某校 5 年详情' tab 显示
 * 拉 /api/site/school-hot?school_name=...
 * 显示:近 24h / 近 7d 次数 + 近 7d 迷你柱状图
 */
import { useEffect, useState } from 'react'
import { getSchoolHot, ApiError, type SchoolHot } from '../lib/api'

const ZERO: SchoolHot = { school_name: '', counts_24h: 0, counts_7d: 0, daily_7d: [0, 0, 0, 0, 0, 0, 0] }

export default function SchoolHotCard({ schoolName }: { schoolName: string }) {
  const [s, setS] = useState<SchoolHot>(ZERO)
  const [err, setErr] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!schoolName) return
    setLoading(true); setErr(null)
    getSchoolHot(schoolName)
      .then(r => setS(r))
      .catch(e => setErr(e instanceof ApiError ? e.message : String((e as Error).message)))
      .finally(() => setLoading(false))
  }, [schoolName])

  const total = s.daily_7d.reduce((a, b) => a + b, 0)
  const max = Math.max(1, ...s.daily_7d)
  const hasData = s.counts_7d > 0

  return (
    <div className="card" style={{ padding: '.75rem', marginBottom: '.75rem', display: 'flex', alignItems: 'center', gap: '1rem', flexWrap: 'wrap' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '.5rem' }}>
        <span className="dot-live" style={{ width: 5, height: 5 }} />
        <span style={{ fontSize: 'var(--fs-capt)', color: 'var(--ink2)' }}>本校热度</span>
      </div>
      {loading && <><div className="progress-bar" style={{ flex: 1, minWidth: 60 }} /></>}
      {err && <span className="mono" style={{ fontSize: 'var(--fs-capt)', color: 'var(--accent)' }}>—</span>}
      {!loading && !err && (
        <>
          <span style={{ fontSize: 'var(--fs-capt)', color: 'var(--ink3)' }}>
            近 24h <span className="mono" style={{ fontWeight: 600, color: 'var(--ink2)' }}>{s.counts_24h}</span> 次
          </span>
          <span style={{ fontSize: 'var(--fs-capt)', color: 'var(--ink3)' }}>
            近 7d <span className="mono" style={{ fontWeight: 600, color: 'var(--ink2)' }}>{s.counts_7d}</span> 次
          </span>
          {hasData && (
            <div style={{ display: 'flex', alignItems: 'flex-end', gap: 3, height: 24 }} title="近 7d 每日查询数">
              {s.daily_7d.map((n, i) => (
                <div key={i} style={{
                  width: 8,
                  height: `${Math.max(2, (n / max) * 100)}%`,
                  minHeight: 2,
                  background: i === 6 ? 'var(--brand)' : 'var(--ink3)',
                  borderRadius: 1,
                  transition: 'height 200ms',
                }} />
              ))}
            </div>
          )}
          {!hasData && (
            <span style={{ fontSize: 'var(--fs-capt)', color: 'var(--ink3)' }}>
              · 暂无用户查询过
            </span>
          )}
        </>
      )}
    </div>
  )
}
